/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2019 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { CreateFactoryManager, CreateJSONManager, CreateStorageManager, CreateModuleManager } from "./common_manager_utils";

// #ENDIF WebPack

var globalEngine = {

//Allows storing data using the registry. Will be defined when engine runs
RegistryStore : null,
//ModuleManager : CreateModuleManager(_factoryManager),
FactoryMap : {},
JsonDataMap: {}

}
// global Variables that must be defined for engine to run properly
var _factoryManager = CreateFactoryManager();             // Defined in Common.js
//Allows loading JS files and registering classes
var ModuleManager = CreateModuleManager(_factoryManager);   // Defined in Common.js
//Allows loading JSON files
var JSONManager = CreateJSONManager();                      // Defined in Common.js
//Allows storing data using the settings manager
var StorageManager = CreateStorageManager();                // Defined in Common.js

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack


//Flag for enabling HttpConnection for UWP
export var enableAnalyticsSDKForUWP = true;

export { globalEngine, _factoryManager, ModuleManager, JSONManager, StorageManager };

// #ENDIF WebPack
